import { apiFetcher } from '../api-fetcher';

/**
 * 장바구니 요약 정보 조회
 *
 * [swagger](http://apidoc.bunjang.co.kr/swagger-ui/index.html?urls.primaryName=bun-order-api%20(%EC%A3%BC%EB%AC%B8)#/%EC%9E%A5%EB%B0%94%EA%B5%AC%EB%8B%88/getUserCart)
 */
export const getCart = () => {
  return apiFetcher.get<{ data: { productCount: number } }>(`/api/order/v1/cart`);
};
